export type ColorMode = "dark" | "light";

export interface ModeTokens {
    bgPage: string;
    bgContent: string;
    bgSidebar: string;
    bgHeader: string;

    textPrimary: string;
    textSecondary: string;
    textMuted: string;
    border: string;

    accent: string;
    accentDim: string;
    accentGlow: string;
    accentText: string;

    tableBg: string,
    tableHeaderBg: string,
    tableRowHover: string,
    tableBorder: string,
    tableHeaderSelectedBg: string,
    tableCellSelectedBg: string,

    cardBg: string,
    cardHover: string,

    inputBg: string,
    inputFocusBg: string,
    inputBorder: string,
    inputFocusBorder: string,
}

export interface AppTheme {
    id: string;
    label: string;
    swatch: string;
    dark: ModeTokens;
    light: ModeTokens;
}

export const THEMES: AppTheme[] = [
    {
        id: "pearl",
        label: "Pearl",
        swatch: "#E5E7EB",
        dark: {
            bgContent: "#1e1e1e",
            bgPage: "#1e1e1e",
            bgSidebar: "#323538",
            bgHeader: "#35383c",

            border: "rgba(255,255,255,0.07)",


            tableBg: "#2b2b2b",
            tableHeaderBg: "#343434",
            tableRowHover: "rgba(0,0,0,0.26)",
            tableBorder: "rgba(201,199,199,0.36)",
            tableHeaderSelectedBg: '#4e4d4d',
            tableCellSelectedBg: '#474646',

            cardBg: "#292a2c",
            cardHover: "#1E2330",

            inputBg: "#42474d",
            inputBorder: "rgba(255,255,255,0.09)",
            inputFocusBorder: "#7C8FFF",
            inputFocusBg: "#7C8FFF",

            textPrimary: "#E2E8F0",
            textSecondary: "#94A3B8",
            textMuted: "#4A5568",

            accent: "#a3a5a7",
            accentDim: "rgba(229, 231, 235, 0.12)",
            accentGlow: "rgba(229, 231, 235, 0.25)",
            accentText: "#111827",


        },
        light: {

            bgPage: "#FDFDFD",
            bgContent: '#FBFBFB',

            bgSidebar: "#F3F4F6",
            bgHeader: 'transparent',

            textPrimary: "#111827",
            textSecondary: "#4B5563",
            textMuted: "#9CA3AF",

            border: "rgba(0, 0, 0, 0.08)",

            accent: "#6B7280",
            accentDim: "rgba(107, 114, 128, 0.12)",
            accentGlow: "rgba(107, 114, 128, 0.20)",
            accentText: "#FFFFFF",

            tableBg: "#fdfdfd",
            tableHeaderBg: "#f8f8f8",
            tableRowHover: "rgba(231,231,231,0.47)",
            tableBorder: "#e2e2e2",
            tableHeaderSelectedBg: '#e7e7e7d1',
            tableCellSelectedBg: '#f3f3f3',


            cardBg: "#ffffff",
            cardHover: "#dedfe0",

            inputBg: "#f9f9f9",
            inputBorder: "#b7b7b7",
            inputFocusBorder: "#E5E7EB",
            inputFocusBg: "#7C8FFF",
        },
    },
    {
        id: "sky",
        label: "Sky",
        swatch: "#38BDF8",
        dark: {
            bgContent: "#1e1e1e",
            bgPage: "#1e1e1e",
            bgSidebar: "#323538",
            bgHeader: "#35383c",

            border: "rgba(255,255,255,0.07)",


            tableBg: "#2b2b2b",
            tableHeaderBg: "#343434",
            tableRowHover: "rgba(255,255,255,0.04)",
            tableBorder: "rgba(201,199,199,0.36)",
            tableHeaderSelectedBg: '#4e4d4d',
            tableCellSelectedBg: '#474646',


            cardBg: "#292a2c",
            cardHover: "#1E2330",

            inputBg: "#42474d",
            inputBorder: "rgba(255,255,255,0.09)",
            inputFocusBorder: "#7C8FFF",
            inputFocusBg: "#7C8FFF",

            textPrimary: "#E2E8F0",
            textSecondary: "#94A3B8",
            textMuted: "#4A5568",


            accent: "#38BDF8",
            accentDim: "rgba(56,  189, 248, 0.12)",
            accentGlow: "rgba(56,  189, 248, 0.25)",
            accentText: "#061826",
        },
        light: {
            bgPage: "#F0F9FF",
            bgContent: '#FBFBFB',
            bgSidebar: "#E0F2FE",
            bgHeader: 'transparent',

            textPrimary: "#0C2D48",
            textSecondary: "#2E6B8A",
            textMuted: "#7AAFC8",
            border: "rgba(0, 0, 0, 0.08)",

            accent: "#0284C7",
            accentDim: "rgba(2,   132, 199, 0.12)",
            accentGlow: "rgba(2,   132, 199, 0.20)",
            accentText: "#FFFFFF",

            tableBg: "#fdfdfd",
            tableHeaderBg: "#f8f8f8",
            tableRowHover: "rgba(231,231,231,0.47)",
            tableBorder: "#e2e2e2",
            tableHeaderSelectedBg: '#e7e7e7d1',
            tableCellSelectedBg: '#f3f3f3',


            cardBg: "#ffffff",
            cardHover: "#dedfe0",

            inputBg: "#f9f9f9",
            inputBorder: "#b7b7b7",
            inputFocusBorder: "#E5E7EB",
            inputFocusBg: "#7C8FFF",
        },
    },
    {
        id: "sage",
        label: "Sage",
        swatch: "#6EE7B7",
        dark: {
            bgContent: "#1e1e1e",
            bgPage: "#1e1e1e",
            bgSidebar: "#323538",
            bgHeader: "#35383c",

            border: "rgba(255,255,255,0.07)",


            tableBg: "#2b2b2b",
            tableHeaderBg: "#343434",
            tableRowHover: "rgba(255,255,255,0.04)",
            tableBorder: "rgba(201,199,199,0.36)",
            tableHeaderSelectedBg: '#4e4d4d',
            tableCellSelectedBg: '#474646',

            cardBg: "#292a2c",
            cardHover: "#1E2330",

            inputBg: "#42474d",
            inputBorder: "rgba(255,255,255,0.09)",
            inputFocusBorder: "#7C8FFF",
            inputFocusBg: "#7C8FFF",

            textPrimary: "#E2E8F0",
            textSecondary: "#94A3B8",
            textMuted: "#4A5568",


            accent: "#6EE7B7",
            accentDim: "rgba(110, 231, 183, 0.12)",
            accentGlow: "rgba(110, 231, 183, 0.25)",
            accentText: "#052013",
        },
        light: {
            bgPage: "#F0FDF4",
            bgContent: '#FBFBFB',
            bgSidebar: "#DCFCE7",
            bgHeader: 'transparent',

            textPrimary: "#052E16",
            textSecondary: "#166534",
            textMuted: "#6BAF8A",
            border: "rgba(0, 0, 0, 0.08)",

            accent: "#059669",
            accentDim: "rgba(5,   150, 105, 0.12)",
            accentGlow: "rgba(5,   150, 105, 0.20)",
            accentText: "#FFFFFF",

            tableBg: "#fdfdfd",
            tableHeaderBg: "#f8f8f8",
            tableRowHover: "rgba(231,231,231,0.47)",
            tableBorder: "#e2e2e2",
            tableHeaderSelectedBg: '#e7e7e7d1',
            tableCellSelectedBg: '#f3f3f3',


            cardBg: "#ffffff",
            cardHover: "#dedfe0",

            inputBg: "#f9f9f9",
            inputBorder: "#b7b7b7",
            inputFocusBorder: "#E5E7EB",
            inputFocusBg: "#7C8FFF",
        },
    },
    {
        id: "violet",
        label: "Violet",
        swatch: "#A78BFA",
        dark: {
            bgContent: "#1e1e1e",
            bgPage: "#1e1e1e",
            bgSidebar: "#323538",
            bgHeader: "#35383c",

            border: "rgba(255,255,255,0.07)",


            tableBg: "#2b2b2b",
            tableHeaderBg: "#343434",
            tableRowHover: "rgba(255,255,255,0.04)",
            tableBorder: "rgba(201,199,199,0.36)",
            tableHeaderSelectedBg: '#4e4d4d',
            tableCellSelectedBg: '#474646',

            cardBg: "#292a2c",
            cardHover: "#1E2330",

            inputBg: "#42474d",
            inputBorder: "rgba(255,255,255,0.09)",
            inputFocusBorder: "#7C8FFF",
            inputFocusBg: "#7C8FFF",

            textPrimary: "#E2E8F0",
            textSecondary: "#94A3B8",
            textMuted: "#4A5568",

            accent: "#A78BFA",
            accentDim: "rgba(167, 139, 250, 0.12)",
            accentGlow: "rgba(167, 139, 250, 0.25)",
            accentText: "#160B2E",

        },
        light: {
            bgPage: "#F5F3FF",
            bgContent: '#FBFBFB',
            bgSidebar: "#EDE9FE",
            bgHeader: 'transparent',

            textPrimary: "#1E0A4A",
            textSecondary: "#5B3F9E",
            textMuted: "#9B82CC",
            border: "rgba(0, 0, 0, 0.08)",

            accent: "#7C3AED",
            accentDim: "rgba(124,  58, 237, 0.12)",
            accentGlow: "rgba(124,  58, 237, 0.20)",
            accentText: "#FFFFFF",

            tableBg: "#fdfdfd",
            tableHeaderBg: "#f8f8f8",
            tableRowHover: "rgba(231,231,231,0.47)",
            tableBorder: "#e2e2e2",
            tableHeaderSelectedBg: '#e7e7e7d1',
            tableCellSelectedBg: '#f3f3f3',


            cardBg: "#ffffff",
            cardHover: "#dedfe0",

            inputBg: "#f9f9f9",
            inputBorder: "#b7b7b7",
            inputFocusBorder: "#E5E7EB",
            inputFocusBg: "#7C8FFF",
        },
    },
    {
        id: "amber",
        label: "Amber",
        swatch: "#FCD34D",
        dark: {
            bgContent: "#1e1e1e",
            bgPage: "#1e1e1e",
            bgSidebar: "#323538",
            bgHeader: "#35383c",

            border: "rgba(255,255,255,0.07)",


            tableBg: "#2b2b2b",
            tableHeaderBg: "#343434",
            tableRowHover: "rgba(255,255,255,0.04)",
            tableBorder: "rgba(201,199,199,0.36)",
            tableHeaderSelectedBg: '#4e4d4d',
            tableCellSelectedBg: '#474646',

            cardBg: "#292a2c",
            cardHover: "#1E2330",

            inputBg: "#42474d",
            inputBorder: "rgba(255,255,255,0.09)",
            inputFocusBorder: "#7C8FFF",
            inputFocusBg: "#7C8FFF",

            textPrimary: "#E2E8F0",
            textSecondary: "#94A3B8",
            textMuted: "#4A5568",

            accent: "#FCD34D",
            accentDim: "rgba(252, 211,  77, 0.12)",
            accentGlow: "rgba(252, 211,  77, 0.25)",
            accentText: "#1C1600",
        },
        light: {
            bgPage: "#FFFBEB",
            bgContent: '#FBFBFB',
            bgSidebar: "#FEF3C7",
            bgHeader: 'transparent',

            textPrimary: "#1C1200",
            textSecondary: "#784E00",
            textMuted: "#B8922A",
            border: "rgba(0, 0, 0, 0.08)",

            accent: "#D97706",
            accentDim: "rgba(217, 119,   6, 0.12)",
            accentGlow: "rgba(217, 119,   6, 0.20)",
            accentText: "#FFFFFF",

            tableBg: "#fdfdfd",
            tableHeaderBg: "#f8f8f8",
            tableRowHover: "rgba(231,231,231,0.47)",
            tableBorder: "#e2e2e2",
            tableHeaderSelectedBg: '#e7e7e7d1',
            tableCellSelectedBg: '#f3f3f3',

            cardBg: "#ffffff",
            cardHover: "#dedfe0",

            inputBg: "#f9f9f9",
            inputBorder: "#b7b7b7",
            inputFocusBorder: "#E5E7EB",
            inputFocusBg: "#7C8FFF",
        },
    },
    {
        id: "rose",
        label: "Rose",
        swatch: "#FDA4AF",
        dark: {
            bgContent: "#1e1e1e",
            bgPage: "#1e1e1e",
            bgSidebar: "#323538",
            bgHeader: "#35383c",

            border: "rgba(255,255,255,0.07)",


            tableBg: "#2b2b2b",
            tableHeaderBg: "#343434",
            tableRowHover: "rgba(255,255,255,0.04)",
            tableBorder: "rgba(201,199,199,0.36)",
            tableHeaderSelectedBg: '#4e4d4d',
            tableCellSelectedBg: '#474646',

            cardBg: "#292a2c",
            cardHover: "#1E2330",

            inputBg: "#42474d",
            inputBorder: "rgba(255,255,255,0.09)",
            inputFocusBorder: "#7C8FFF",
            inputFocusBg: "#7C8FFF",

            textPrimary: "#E2E8F0",
            textSecondary: "#94A3B8",
            textMuted: "#4A5568",


            accent: "#FDA4AF",
            accentDim: "rgba(253, 164, 175, 0.12)",
            accentGlow: "rgba(253, 164, 175, 0.25)",
            accentText: "#200610",

        },
        light: {
            bgPage: "#FFF1F2",
            bgContent: '#FBFBFB',
            bgSidebar: "#FFE4E6",
            bgHeader: 'transparent',

            textPrimary: "#1A0610",
            textSecondary: "#9F1239",
            textMuted: "#C47A8A",
            border: "rgba(0, 0, 0, 0.08)",

            accent: "#E11D48",
            accentDim: "rgba(225,  29,  72, 0.12)",
            accentGlow: "rgba(225,  29,  72, 0.20)",
            accentText: "#FFFFFF",

            tableBg: "#fdfdfd",
            tableHeaderBg: "#f8f8f8",
            tableRowHover: "rgba(231,231,231,0.47)",
            tableBorder: "#e2e2e2",
            tableHeaderSelectedBg: '#e7e7e7d1',
            tableCellSelectedBg: '#f3f3f3',

            cardBg: "#ffffff",
            cardHover: "#dedfe0",

            inputBg: "#f9f9f9",
            inputBorder: "#b7b7b7",
            inputFocusBorder: "#E5E7EB",
            inputFocusBg: "#7C8FFF",
        },
    },
];

export const DEFAULT_THEME = THEMES[1];
export const DEFAULT_MODE: ColorMode = "light";

export function applyTheme(theme: AppTheme, mode: ColorMode): void {
    const tokens = theme[mode];
    const root = document.documentElement;


    root.style.setProperty("--pn-bg-page", tokens.bgPage);
    root.style.setProperty("--pn-bg-content", tokens.bgContent);
    root.style.setProperty("--pn-bg-sidebar", tokens.bgSidebar);
    root.style.setProperty("--pn-bg-header", tokens.bgHeader);
    root.style.setProperty("--pn-bg-card", tokens.cardBg);
    root.style.setProperty("--pn-bg-input", tokens.inputBg);
    root.style.setProperty("--pn-bg-table", tokens.tableBg);
    root.style.setProperty("--pn-bg-input-focused", tokens.inputFocusBg);
    root.style.setProperty("--pn-bg-table-header-selected", tokens.tableHeaderSelectedBg);
    root.style.setProperty("--pn-bg-table-cell-selected", tokens.tableCellSelectedBg);

    root.style.setProperty("--pn-header-table", tokens.tableHeaderBg);
    root.style.setProperty("--pn-hover-card", tokens.cardHover);
    root.style.setProperty("--pn-hover-table-row", tokens.tableRowHover);


    root.style.setProperty("--pn-text-primary", tokens.textPrimary);
    root.style.setProperty("--pn-text-secondary", tokens.textSecondary);
    root.style.setProperty("--pn-text-muted", tokens.textMuted);

    root.style.setProperty("--pn-border", tokens.border);
    root.style.setProperty("--pn-border-table", tokens.tableBorder);
    root.style.setProperty("--pn-border-input", tokens.inputBorder);
    root.style.setProperty("--pn-border-input-focused", tokens.inputFocusBorder);


    root.style.setProperty("--pn-accent", tokens.accent);
    root.style.setProperty("--pn-accent-dim", tokens.accentDim);
    root.style.setProperty("--pn-accent-glow", tokens.accentGlow);
    root.style.setProperty("--pn-accent-text", tokens.accentText);

    root.style.setProperty("--pn-table", tokens.accent);
    root.style.setProperty("--pn-accent-glow", tokens.accentGlow);
    root.style.setProperty("--pn-accent-text", tokens.accentText);


    root.setAttribute("data-mode", mode);
}

const THEME_KEY = "pn:theme";
const MODE_KEY = "pn:mode";

export function persistPreferences(themeId: string, mode: ColorMode): void {
    try {
        localStorage.setItem(THEME_KEY, themeId);
        localStorage.setItem(MODE_KEY, mode);
    } catch {
    }
}

export function restorePreferences(): { theme: AppTheme; mode: ColorMode } {
    try {
        const themeId = localStorage.getItem(THEME_KEY);
        const mode = localStorage.getItem(MODE_KEY) as ColorMode | null;
        return {
            theme: THEMES.find(t => t.id === themeId) ?? DEFAULT_THEME,
            mode: (mode === "light" || mode === "dark") ? mode : DEFAULT_MODE,
        };
    } catch {
        return {theme: DEFAULT_THEME, mode: DEFAULT_MODE};
    }
}
